var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAssistenciaTecnicaSensia = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 90,
  height: 88,
  viewBox: "0 0 90 88",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.07004 10.1803C5.44132 10.1803 3.30989 12.1864 3.30989 14.6611L0 83.5197C0 85.9943 2.13143 88 4.76016 88H84.3125C86.9417 88 89.0732 85.9943 89.0732 83.5197L84.816 4.48079C84.816 2.00614 82.6846 0 80.0554 0L8.07004 10.1803Z",
  fill: "#162C2B",
  fillOpacity: 0.05
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.4084 23.8875C31.8032 21.0378 38.5178 22.0231 43.0065 26.8858C46.9741 31.184 48.1533 37.3401 46.5747 42.7556L61.7413 59.2068C61.7422 59.2079 61.7432 59.2089 61.7442 59.21C64.396 62.0583 64.3884 66.684 61.7489 69.5463C59.1188 72.4201 54.8471 72.411 52.2051 69.5489L36.9431 53.015C32.0089 54.6216 26.411 53.3269 22.5051 49.0955C18.0166 44.2329 17.1089 37.0054 19.7143 31.1432L20.6315 29.0795L29.3999 38.5787C29.5912 38.7912 29.8805 38.7913 30.0718 38.5787L30.0851 38.564L33.2651 35.1191C33.4594 34.9087 33.4594 34.5726 33.2651 34.3622L24.518 24.8861L26.4084 23.8875ZM29.7698 25.9794L35.3865 32.0641C36.7523 33.5437 36.7523 35.9376 35.3865 37.4172L32.2123 40.8559C30.8455 42.3656 28.6262 42.3656 27.2593 40.8559L21.6559 34.7855C20.6369 38.949 21.6246 43.5454 24.6265 46.7974C27.9126 50.3574 32.7249 51.3021 36.8171 49.6324L37.7224 49.2631L54.3265 67.2508C55.8036 68.851 58.1698 68.8429 59.62 67.2564L59.6251 67.2508C61.1022 65.6506 61.0948 63.0872 59.6303 61.5161L59.6245 61.5098L43.0905 43.5754L43.4498 42.5852C45.0802 38.0927 44.2264 32.8035 40.8851 29.1839C37.8815 25.9299 33.6089 24.862 29.7698 25.9794Z",
  fill: "#86AA63",
  stroke: "#86AA63",
  strokeWidth: 0.4
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAssistenciaTecnicaSensia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/assistencia_tecnica_sensia.11e5b46ba5722d76ff6e9586de1b6a39.svg";